/**
 * openDatabaseBlueprintTab
 *
 * Opens (or activates) a Database Blueprint workspace tab for a given mounted folder.
 * If a tab already exists for the same blueprintFolderId, it is activated rather
 * than duplicated.
 */

import { useWorkspaceStore } from '../../workspace/core/store/workspaceStore';
import {
  isDatabaseBlueprintTab,
  createDefaultDatabaseBlueprintContent,
} from '../../workspace/core/types/workspaceTypes';

export function openDatabaseBlueprintTab(blueprintFolderId: string, label: string): string {
  const { tabs, setActiveTab, addTab } = useWorkspaceStore.getState();

  const existing = tabs.find(
    (t) => isDatabaseBlueprintTab(t) && t.content.blueprintFolderId === blueprintFolderId,
  );
  if (existing) {
    setActiveTab(existing.id);
    return existing.id;
  }

  const id = addTab({
    type: 'database-blueprint',
    title: `Blueprint: ${label}`,
    content: createDefaultDatabaseBlueprintContent(blueprintFolderId),
  });

  if (typeof window !== 'undefined') {
    window.electronAPI?.analytics
      ?.track('feature:database_blueprint_open_tab', { source: 'scripts-panel' })
      .catch(() => {
        /* fire-and-forget */
      });
  }

  return id;
}
